<script>
import { convertCurrency } from '~/assets/js/methods';

export default {
    name: 'Sumary',
    setup() {
        return {
            convertCurrency
        }
    },
    computed: {
        getSumary() {
            return this.$store.getters['getSumary'];
        },
        getPaymentMethodSelected() {
            return this.$store.getters['getPaymentMethodSelected'];
        },
        getSetup() {
            return this.$store.getters['getSetup'];
        }
    },
    methods: {
        getAmoutByItem(item) {
            let subtotal = parseInt((item.sale_price * item.quantity));
            let discount = 0;
            if (typeof item.discount_data !== 'undefined') {
                discount = parseInt(((item.sale_price * item.discount_data.percent) * item.quantity) / 100);
            }

            return {
                discount: discount,
                subtotal: subtotal,
                amount_avista: (subtotal - discount),
                unit_price: parseInt((subtotal - discount) / item.quantity)
            }

        }
    },
    data() {
        return {

        }
    }
}
</script>
<template>
    <div class="sm:mt-3">
        <dl class="space-y-6 border-gray-200 px-0">
            <div class="flex items-center justify-between pt-2">
                <dt class="text-xl font-bold text-left">Total:</dt>
                <dd class="text-md font-medium text-gray-900  leading-none text-right"
                    v-if="getPaymentMethodSelected === 1 && getSumary.total_amount > 0">
                    {{ convertCurrency(getSumary.total_amount / 100, 'R$ ', 2) }} ou {{ getSumary.installments }}x
                    {{ convertCurrency(getSumary.amount_installment / 100, 'R$ ', 2) }}
                </dd>
                <dd class="text-2xl font-medium text-gray-900  leading-none text-right" v-else>
                    {{ convertCurrency(getSumary.total_amount / 100, 'R$ ', 2) }}
                </dd>
            </div>
        </dl>
    </div>
</template>
